import { toasts, dismiss } from '../lib/toast';
import { Icon } from './Icon';

/** Renders the current toast queue. Mount once, near the root (see AppShell). */
export function ToastHost() {
  if (toasts.value.length === 0) return null;
  return (
    <div class="c-toast-host" role="region" aria-label="Notifications">
      {toasts.value.map((t) => (
        <div class={`c-toast c-toast--${t.kind}`} key={t.id} role="status">
          <Icon name={t.kind === 'success' ? 'check' : t.kind === 'error' ? 'x' : t.kind === 'warn' ? 'warning' : 'info'} size={16} />
          <span>{t.message}</span>
          <button type="button" class="c-toast__dismiss" onClick={() => dismiss(t.id)} aria-label="Dismiss notification">
            <Icon name="close" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
